/* unplugin-vue-components disabled */import { render } from "./memberList.vue?vue&type=template&id=16abf3b2&scoped=true"
import script from "./memberList.vue?vue&type=script&lang=js"
export * from "./memberList.vue?vue&type=script&lang=js"

import "./memberList.vue?vue&type=style&index=0&id=16abf3b2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16abf3b2"]])

export default __exports__